//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions, mapGetters } from "vuex";
import Theme from "@/listing-app/mixins/Theme";
import ExpandTransition from "@/listing-app/components/ExpandTransition";
import Select from "./filters/Select";
import MultiSelect from "./filters/MultiSelect";
import Range from "./filters/Range";
import Meta from "./filters/Meta";

export default {
  name: "Filters",
  mixins: [Theme],
  props: ["terms", "data"],
  components: {
    appExpandTransition: ExpandTransition,
    appSelect: Select,
    appMultiSelect: MultiSelect,
    appRange: Range,
    appMeta: Meta
  },
  data() {
    return {
      drawerOpen: false
    };
  },
  computed: {
    ...mapGetters(["read"]),
    term() {
      return this.read("term");
    },
    count() {
      return this.terms.Type == "select" ? 2 : 3;
    }
  },
  methods: {
    ...mapActions(["set"]),
    reset() {
      this.set({muta: 'clear_filters', data: null})
      this.data.forEach(filter => {
        if (filter.Type == "select") {
          let defaultAvailable = false;
          filter.Values.forEach(option => {
            if (option.hasOwnProperty("Default") && option.Default == true) {
              this.set({
                muta: "filters",
                data: {
                  filter: filter.ID,
                  value: option.ID,
                  text: option.Text
                }
              });
              defaultAvailable = true;
            }
          });
          if (!defaultAvailable) {
            this.set({
              muta: "filters",
              data: {
                filter: filter.ID,
                value: filter.Values[0].ID,
                text: filter.Values[0].Text
              }
            });
          }
        } else if (filter.Type == "multiselect") {
          let defaultAvailable = false;
          let multi = filter.Values.reduce((_multi, option) => {
            if (option.hasOwnProperty("Default") && option.Default == true) {
              defaultAvailable = true;
              _multi.push({ value: option.ID, text: option.Text });
            }
            return _multi;
          }, []);

          if (defaultAvailable) {
            this.set({
              muta: "filters",
              data: {
                filter: filter.ID,
                multi
              }
            });
          } else {
            this.set({
              muta: "filters",
              data: {
                filter: filter.ID,
                multi: [
                  { value: filter.Values[0].ID, text: filter.Values[0].Text }
                ]
              }
            });
          }
        } else if (filter.Type == "range") {
          this.set({
            muta: "filters",
            data: {
              filter: filter.ID,
              value: filter.Values.Max
            }
          });
        }
      });
    }
  },
  watch: {
    term() {
      this.reset();
    }
  },
  mounted() {
    if (!this.read("initialLoad")) {
      this.reset();
    } else {
      this.set({ muta: "initialLoad", data: false });
    }
  }
};
